import { render } from "./PrenotazioniInfoPage.vue?vue&type=template&id=8034b52c&scoped=true"
import script from "./PrenotazioniInfoPage.vue?vue&type=script&lang=js"
export * from "./PrenotazioniInfoPage.vue?vue&type=script&lang=js"

import "./PrenotazioniInfoPage.vue?vue&type=style&index=0&id=8034b52c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8034b52c"]])

export default __exports__